import { render, staticRenderFns } from "./ConstantBanner.vue?vue&type=template&id=cc5668ca&"
import script from "./ConstantBanner.vue?vue&type=script&lang=js&"
export * from "./ConstantBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc5668ca')) {
      api.createRecord('cc5668ca', component.options)
    } else {
      api.reload('cc5668ca', component.options)
    }
    module.hot.accept("./ConstantBanner.vue?vue&type=template&id=cc5668ca&", function () {
      api.rerender('cc5668ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ConstantBanner.vue"
export default component.exports